import React from "react";
import asianArtifactsImage from '../../images/art-asiatique.JPG';
import CategoryPage from '../CategoryPage';
import { CATEGORIES_SEO } from '../../seo/pagesSeo';

function ArtsAsiatiquesPage() {
    const seo = CATEGORIES_SEO['arts-asiatiques'];
    const details = [
        "Bijoux en jade ou autres pierres précieuses",
        "Sculptures en bronze, corail et autres matériaux",
        "Vases en porcelaine (Chine, Japon, Corée)",
        "Textiles cloisonnés (Kimono, Tapisserie, Broderie)",
        "Meubles en laque ou meubles chinois anciens",
        "Sabres japonais (Katana, Wakizashi)",
        "Armures de samouraïs",
        "Sculptures en bois, jade ou bronze",
        "Statues bouddhistes",
        "Céramiques et poteries anciennes",
        "Boîtes en laque (lacquerware)",
        "Objets de guerre (casques, épées, samouraïs, armures, boucliers)",
        "Masques rituels (Tibet, Bali, Japon)",
        "Calligraphies anciennes",
    ];

    return (
        <CategoryPage
            title="Objets Asiatiques"
            image={asianArtifactsImage}
            description="En tant qu'antiquaire expert, je rachète avec passion tout type d'objet asiatique, qu'il s'agisse de mobilier, de sculptures, ou d'objets de guerre. Mon expertise couvre une large gamme d'objets d'art provenant des grandes civilisations asiatiques, et je suis particulièrement attiré par des pièces rares et authentiques, qu'elles soient anciennes ou modernes. Chaque objet, qu'il soit en jade, en laque, ou en bronze, porte l'histoire et l'élégance de cultures millénaires."
            details={details}
            seoTitle={seo.title}
            seoDescription={seo.description}
            seoPath={seo.path}
        />
    );
}

export default ArtsAsiatiquesPage;
